import { render, staticRenderFns } from "./slaInfo.vue?vue&type=template&id=f85a325a&scoped=true"
import script from "./slaInfo.vue?vue&type=script&lang=js"
export * from "./slaInfo.vue?vue&type=script&lang=js"
import style0 from "./slaInfo.vue?vue&type=style&index=0&id=f85a325a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a325a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85a325a')) {
      api.createRecord('f85a325a', component.options)
    } else {
      api.reload('f85a325a', component.options)
    }
    module.hot.accept("./slaInfo.vue?vue&type=template&id=f85a325a&scoped=true", function () {
      api.rerender('f85a325a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformManage/baseInfo/slaInfo.vue"
export default component.exports